export const moreInfoBtnStyles = {
  color: "#2F2B3D",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  textDecoration: "underline",
  cursor: "pointer",
};

export const accordianWrapper = {
  borderRadius: "16px !important",
  boxShadow: "none",
  border: "1px solid #EAEAEA",

  "&.Mui-expanded": {
    m: 0,
    borderBottomLeftRadius: { xs: "0px !important", sm: "16px !important" },
    borderBottomRightRadius: { xs: "0px !important", sm: "16px !important" },
  },

  ":before": {
    height: "0px",
  },
};

export const accordianSummary = (isSmallScreen) => ({
  py: "24px",
  px: "16px",
  gap: "8px",

  "& .MuiAccordionSummary-content": {
    m: "0px !important",
    order: isSmallScreen ? 2 : 1,
  },

  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "#2F2B3D",
    order: isSmallScreen ? 1 : 2,
  },
});

export const accordianDetailStyles = (isSmallScreen) => ({
  padding: isSmallScreen ? "0px" : "16px",
  pt: "0px",
  // boxShadow: "0px -2px 8px 0px #00000029",
});

export const tableContainerStyles = (isSmallScreen, hasVerticalScroll) => ({
  maxHeight: 400,
  overflow: "auto",
  // borderRadius: { xs: "0px", sm: "8px" },
  background: isSmallScreen ? "#F9F9FC" : "#FFFFFF",
  paddingRight: hasVerticalScroll ? "8px" : 0,

  "& thead": {
    position: "relative",
    zIndex: 99,
  },

  "& th": {
    color: "#3E3F4CBF",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "18px",
    paddingY: "16px",
    paddingX: "12px",
    borderLeft: "1px solid #EAEAEA",
    whiteSpace: "nowrap",
    background: isSmallScreen ? "#F9F9FC" : "#FFFFFF",
    borderBottom: "1px solid #EAEAEA",
    borderTop: "1px solid #EAEAEA",
    "&:last-child": {
      borderRight: "1px solid #EAEAEA",
    },
  },

  "& td": {
    color: "#2F2B3D",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    padding: "12px",
    height: "44px",
    borderLeft: "1px solid #EAEAEA",
    borderBottom: "1px solid #EAEAEA",
    "&:last-child": {
      borderRight: "1px solid #EAEAEA",
    },
  },
});

export const infoIconStyles = {
  fontSize: "19px",
  color: "rgba(47, 43, 61, 1)",
  cursor: "pointer",
};

export const bottomShadowStyles = {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  height: "10px",
  background: "linear-gradient(to top, rgba(0,0,0,0.08), rgba(0,0,0,0))",
  zIndex: 10,
  pointerEvents: "none",
};

export const topShadowStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "10px",
  background: "linear-gradient(to bottom, rgba(0,0,0,0.08), rgba(0,0,0,0))",
  zIndex: 10,
  pointerEvents: "none",
};

export const VATTextStyles = {
  color: "rgba(72, 72, 72, 1)",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  padding: { xs: "16px", sm: "0px" },
  paddingTop: { xs: "16px", sm: "16px" },
};

export const tableHeadCellStyles = (
  column,
  index,
  config,
  hasHorizontalScroll
) => ({
  ...(column.headerStyle || {}),
  ...(column.cellStyle || {}),

  borderTopLeftRadius: index === 0 ? { xs: 0, sm: "8px" } : 0,
  borderTopRightRadius:
    index === config.columns.length - 1 ? { xs: 0, sm: "8px" } : 0,

  ...(column.id === "variant"
    ? {
        minWidth: "131px",
        position: "sticky",
        left: 0,
        backgroundColor: { xs: "#F9F9FC", sm: "#FFFFFF" },
        zIndex: 9,
        borderLeftWidth: {
          xs: "0px !important",
          sm: "1px !important",
        },
        boxShadow: hasHorizontalScroll
          ? "4px 0px 8px -3px rgba(0,0,0,0.12)"
          : "none",
      }
    : {}),
});

export const tableVariantCellStyles = (
  column,
  isLastRow,
  hasHorizontalScroll
) => ({
  position: "sticky",
  left: 0,
  backgroundColor: { xs: "#F9F9FC", sm: "#FFFFFF" },
  zIndex: 1,
  borderLeftWidth: {
    xs: "0px !important",
    sm: "1px !important",
  },
  boxShadow: hasHorizontalScroll ? "4px 0px 8px -3px rgba(0,0,0,0.12)" : "none",
  borderBottomLeftRadius: isLastRow ? { xs: 0, sm: "8px" } : undefined,
  // verticalAlign: "top",
  ...(column.cellStyle || {}),
});

export const regularCellStyles = (column) => ({
  textTransform: column.id === "unit" ? "capitalize" : "none",
  ...(column.cellStyle || {}),
});

export const marketPriceCellStyles = (isLastRow, column) => ({
  borderBottomRightRadius: isLastRow ? { xs: 0, sm: "8px" } : undefined,
  ...(column.cellStyle || {}),
});

export const variantCellBoxStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "4px",
  color: "#2F2B3D",
};

export const marketCellBoxStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "4px",
  color: "rgba(72, 72, 72, 1)",
};
